import { render } from "./CheckMarkBlack.vue?vue&type=template&id=cca5a046"
import script from "./CheckMarkBlack.vue?vue&type=script&lang=js"
export * from "./CheckMarkBlack.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/application/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__